<script setup lang="ts">
import { Color, ColorSemantic } from '@previo/codebooks'
import { QItem } from 'quasar'
import { computed } from 'vue'
import { PFlagSize } from '../../../flag/types'
import PSpace from '../../../space/PSpace.vue'
import PTextFormBody from '../../../typography/form/PTextFormBody.vue'
import PTextLink from '../../../typography/links/PTextLink.vue'
import { PSpaceSize } from '../../../space/types'
import PFlag from '../../../flag/PFlag.vue'
import { type PPhoneInputFieldDialCode, type PPhoneInputFieldType } from '../../types'

const model = defineModel<PPhoneInputFieldType | null>({ default: null })

type Emits = {
  (e: 'selected'): void
}

const emits = defineEmits<Emits>()

type Props = {
  item: PPhoneInputFieldDialCode
  color?: Color | ColorSemantic
}

const props = withDefaults(defineProps<Props>(), {
  color: Color.WHITE,
})

const selectDialCode = (): void => {
  model.value = {
    dialCodeId: props.item.id,
    number: model.value?.number ?? null,
  }

  emits('selected')
}

const isItemSelected = computed<boolean>(() => {
  return model.value?.dialCodeId === props.item.id
})
</script>

<template>
  <q-item
    :key="item.id"
    :active="isItemSelected"
    :class="['p-cursor-pointer', `bg-${color}`]"
    style="padding: unset"
    clickable
    @click="selectDialCode"
  >
    <div class="p-flex p-items-center p-no-wrap p-full-width" style="padding: 12px">
      <p-flag :country-iso3="item.countryCodeIso3" :size="PFlagSize.SMALL" />
      <p-space :mobile="PSpaceSize.SM" />
      <p-text-form-body
        :text="item.dialCode"
        style="width: 60px"
        :color="isItemSelected ? Color.PRIMARY : Color.GREY_500"
      />
      <p-space :mobile="PSpaceSize.SM" />
      <p-text-link
        :text="item.countryName"
        :color="isItemSelected ? Color.PRIMARY : Color.GREY_600"
      />
    </div>
  </q-item>
</template>
